// extracted by mini-css-extract-plugin
export default {"manageApps":"h_mwuJXsSmOuSWe526tY"};